module.exports = __webpack_public_path__ + "img/15.f51fe761.jpg";